
import { createWebHashHistory, createRouter } from "vue-router";



const routes = [
  {
    path: "/",
    name: "SetupUserType",
    //component: SetupUserType,
    component: () => import(/* webpackChunkName: "setup" */ '@/components/SetupUserType.vue'),
    // beforeEnter: [loadSettings],
  },
  {
    path: "/vwnw/:roomname/:user/:groupname",
    name: "SetupFromVWNW",
    //component: SetupUserType,
    component: () => import(/* webpackChunkName: "setup" */ '@/components/SetupFromVWNW.vue'),
    // beforeEnter: [loadSettings],
  },
  {
    path: "/setup/student",
    name: "setupStudent",
    component: () => import(/* webpackChunkName: "student-setup" */ "@/components/student/setup/SetupStudent.vue")
  },
  {
    path: "/setup/begeleider",
    name: "SetupBegeleider",
    component: () => import(/* webpackChunkName: "setup" */ '@/components/begeleider/setup/SetupBegeleider.vue')
  },
  {
    path: '/setup/room',
    name: "SetupRoomName",
    component: () => import(/* webpackChunkName: "setup" */ '@/components/SetupRoomName.vue')
  },
  {
    path: '/setup/student/session',
    name: "SetupSession",
    component: () => import(/* webpackChunkName: "student-setup" */ '@/components/student/setup/SetupSession.vue')
  },
  {
    path: '/setup/student/group',
    name: "setupGroup",
    component: () => import(/* webpackChunkName: "student-setup" */ "@/components/student/setup/SetupGroupName.vue")
  },
  {
    path: "/setup/begeleider/time",
    name: "setupTime",
    component: () => import(/* webpackChunkName: "begeleider-setup" */ '@/components/begeleider/setup/SetDurationScreen.vue')
  },
  {
    path: "/setup/begeleider/level",
    name: "setupLevel",
    component: () => import(/* webpackChunkName: "begeleider-setup" */ '@/components/begeleider/setup/SetLevelScreen.vue')
  },
  {
    path: "/setup/begeleider/rounds",
    name: "setupRounds",
    component: () => import(/* webpackChunkName: "begeleider-setup" */ "@/components/begeleider/setup/SetRoundsScreen.vue")
  },
  {
    path: "/begeleider/map/:option",  // setup-endgame, setup-locations, start-game, game
    name: "MapBegeleider",
    component: () => import(/* webpackChunkName: "map" */ "@/components/begeleider/MapScreenBegeleider.vue"),
  },
  {
    path: "/begeleider/endgame/:option", 
    name: "EndgameBegeleider",
    component: () => import(/* webpackChunkName: "map" */ "@/components/begeleider/EndGameScreenBegeleider.vue"),
  },
  {
    path: "/student/instructions/",
    name: "Instructions",
    component: () => import(/* webpackChunkName: "map" */ "@/components/InstructionsScreen.vue"),
  },
  {
    path: "/student/map/:option",
    name: "Map",
    component: () => import(/* webpackChunkName: "map" */ "@/components/student/MapScreen.vue"),
  },
  {
    path: "/student/endgame/:option",
    name: "EndGame",
    component: () => import(/* webpackChunkName: "map" */ "@/components/student/EndGameScreen.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;